export default __webpack_public_path__ + "static/media/SA4.7b897282.png";